<template>
    <div class="ht-tab-wrap">
      <div class="section-title-wrapper text-center section-space--mb_30">
        <h5 class="section-title font-width-light wow move-up">Ongles incarnés</h5>
      </div>
      <div class="row">
<!--        <div class="col-md-4">-->
<!--          <img class="img-fluid" src="@/assets/img/pied-pro/services/ongle-incarne1.jpg" alt="product-details" />-->
<!--        </div>-->
        <div class="col-md-12" style="color: #05052d">
          <div class="float-left" style="width: 300px; margin-right: 20px;">
            <img class="img-fluid" src="@/assets/img/pied-pro/services/ongle-incarne3.png" alt="=Ongles incarnés" />
          </div>
          L’ongle incarné est un problème courant qui peut devenir très douloureux et parfois
          même incapacitant.
          <br><br>
          Il se caractérise par un ongle qui pénètre dans la peau qui
          l’entoure provoquant ainsi une inflammation, une rougeur et une enflure. Il peut
          éventuellement causer une infection avec l’apparition d’un écoulement purulent.
          <div class="float-right" style="width: 300px; margin: 20px;">
            <img class="img-fluid" src="@/assets/img/pied-pro/services/ongle-incarne1.jpg" alt="=Ongles incarnés" />
          </div>
          <br><br>
          Touchant plus souvent l’ongle du gros orteil, il peut être causé par une mauvaise
          coupe d’ongle ou par le port de chaussures trop étroites. Il doit être pris en charge
          rapidement pour éviter toute complication.
        </div>
      </div>
    </div>
</template>

<script>
    export default {
        name: 'OnglesIncarnes',
    };
</script>